import { MutationTree } from 'vuex';

import { State } from './state';
import { LanguageMutationTypes } from '@/core/enums/Lang/Mutations';

export type Mutations<S = State> = {
  [LanguageMutationTypes.SET_LANG](state: S, payload: string): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [LanguageMutationTypes.SET_LANG](state: State, lang: string) {
    state.lang = lang;
  },
};
